function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  // update() {
  //   // Temporarily prevents unneeded updates resulting from variant changes
  //   // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
  //   if (!this.slider || !this.nextButton) return;

  //   const previousPage = this.currentPage;
  //   this.currentPage =
  //     Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

  //   if (this.currentPageElement && this.pageTotalElement) {
  //     this.currentPageElement.textContent = this.currentPage;
  //     this.pageTotalElement.textContent = this.totalPages;
  //   }

  //   if (this.currentPage != previousPage) {
  //     this.dispatchEvent(
  //       new CustomEvent("slideChanged", {
  //         detail: {
  //           currentPage: this.currentPage,
  //           currentElement: this.sliderItemsToShow[this.currentPage - 1],
  //         },
  //       })
  //     );
  //   }

  //   if (this.enableSliderLooping) return;

  //   if (
  //     this.isSlideVisible(this.sliderItemsToShow[0]) &&
  //     this.slider.scrollLeft === 0
  //   ) {
  //     this.prevButton.setAttribute("disabled", "disabled");
  //   } else {
  //     this.prevButton.removeAttribute("disabled");
  //   }

  //   if (
  //     this.isSlideVisible(
  //       this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
  //     )
  //   ) {
  //     this.nextButton.setAttribute("disabled", "disabled");
  //   } else {
  //     this.nextButton.removeAttribute("disabled");
  //   }
  // }

  update() {
  if (!this.slider || !this.nextButton) return;

  const previousPage = this.currentPage;
  this.currentPage =
    Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

  if (this.currentPageElement && this.pageTotalElement) {
    this.currentPageElement.textContent = this.currentPage;
    this.pageTotalElement.textContent = this.totalPages;
  }

  if (this.currentPage != previousPage) {
    this.dispatchEvent(
      new CustomEvent("slideChanged", {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1],
        },
      })
    );
  }

  if (this.enableSliderLooping) return;

  // ✅ Only apply fix for thumbnail slider
  if (this.id && this.id.includes("Thumbnails")) {
    this.prevButton.disabled = this.currentPage === 1;
    this.nextButton.disabled = this.currentPage === this.totalPages;
    return; // stop here, don’t run default logic
  }

  // Default logic for other sliders (main gallery etc.)
  if (
    this.isSlideVisible(this.sliderItemsToShow[0]) &&
    this.slider.scrollLeft === 0
  ) {
    this.prevButton.setAttribute("disabled", "disabled");
  } else {
    this.prevButton.removeAttribute("disabled");
  }

  if (
    this.isSlideVisible(
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
    )
  ) {
    this.nextButton.setAttribute("disabled", "disabled");
  } else {
    this.nextButton.removeAttribute("disabled");
  }
}


  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this)
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.filterImgVariant();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  filterImgVariant() {
    var optionBunle1 = $("input[name='Packs']:checked").val();

    setTimeout(function () {
      // Get the Skio plan picker and product form elements
      const skioPlanPicker = document.querySelector("skio-plan-picker");
      const quantityElement = document.querySelector(".product-form__quantity");
      const infotool = document.querySelector(".svgspath.tooltip");

      // Function to update button text and quantity visibility
      function updateButtonAndQuantity() {
        const isSubscriptionSelected = !!skioPlanPicker.selectedSellingPlan; // Check if Skio has a subscription selected

        if (quantityElement) {
          quantityElement.style.display = isSubscriptionSelected
            ? "none"
            : "block";
        }

        if (infotool) {
          infotool.style.display = isSubscriptionSelected ? "block" : "none";
        }
      }

      // Initial update when page loads
      updateButtonAndQuantity();

      // Listen for Skio plan changes
      skioPlanPicker.addEventListener("skio::update-selling-plan", function () {
        updateButtonAndQuantity();
      });
    }, 2000);

    console.log(
      this.currentVariant.option1,
      this.currentVariant.option2,
      "current"
    );






    if (
      this.currentVariant.featured_image &&
      this.currentVariant.featured_image.alt
    ) {
      console.log(
        "Variant options:",
        this.currentVariant.option1,
        this.currentVariant.option2
      );
      if (window.location.pathname.includes("elyte-t-shirt")) {
        let gender = this.currentVariant.option1; // Adjust if Gender is option2

        // Hide all thumbnails
        document.querySelectorAll("[thumbnail-alt]").forEach((img) => {
          img.style.display = "none";
        });

        // Show based on gender
        if (gender === "Male") {
          document
            .querySelectorAll("[thumbnail-alt='mshirt']")
            .forEach((img) => {
              img.style.display = "block";
            });
        } else if (gender === "Female") {
          document
            .querySelectorAll("[thumbnail-alt='fshirt']")
            .forEach((img) => {
              img.style.display = "block";
            });
        }
      }

      // Wildberry

      if (
        this.currentVariant.option1 == "Wildberry" &&
        this.currentVariant.option2 == "12 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#8554f7");
        $(".nutrition-table").css("color", "#fff");
        $(".ingredients").css("border-top-color", "#fff");
        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "w12";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "wmain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      } else if (
        this.currentVariant.option1 == "Wildberry" &&
        this.currentVariant.option2 == "30 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#8554f7");
        $(".nutrition-table").css("color", "#fff");
        $(".ingredients").css("border-top-color", "#fff");
        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "w30";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "wmain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      }

      // Citrus

      if (
        this.currentVariant.option1 == "Citrus" &&
        this.currentVariant.option2 == "12 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#DFF940");
        $(".nutrition-table").css("color", "rgba(26, 38, 46, 0.80)");
        $(".ingredients").css("border-top-color", "rgba(26, 38, 46, 0.40)");
        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "c12";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "cmain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      } else if (
        this.currentVariant.option1 == "Citrus" &&
        this.currentVariant.option2 == "30 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#DFF940");
        $(".nutrition-table").css("color", "rgba(26, 38, 46, 0.80)");
        $(".ingredients").css("border-top-color", "rgba(26, 38, 46, 0.40)");
        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "c30";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "cmain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      }

      // Orange Zest

      if (
        this.currentVariant.option1 == "Orange Zest" &&
        this.currentVariant.option2 == "12 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#ffa500");
        $(".nutrition-table").css("color", "#fff");
        $(".ingredients").css("border-top-color", "#fff");
        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "o12";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "omain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      } else if (
        this.currentVariant.option1 == "Orange Zest" &&
        this.currentVariant.option2 == "30 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#ffa500");
        $(".nutrition-table").css("color", "#fff");
        $(".ingredients").css("border-top-color", "#fff");

        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "o30";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "omain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      }

      // Pineapple - 30 Stick Sachets

      if (
        this.currentVariant.option1 == "Pineapple" &&
        this.currentVariant.option2 == "12 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#FEDA00");
        $(".nutrition-table").css("color", "rgba(26, 38, 46, 0.80)");
        $(".ingredients").css("border-top-color", "rgba(26, 38, 46, 0.40)");
        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "p12";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "pmain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      } else if (
        this.currentVariant.option1 == "Pineapple" &&
        this.currentVariant.option2 == "30 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#FEDA00");
        $(".nutrition-table").css("color", "rgba(26, 38, 46, 0.80)");
        $(".ingredients").css("border-top-color", "rgba(26, 38, 46, 0.40)");

        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "p30";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "pmain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      }
      
      // Unflavoured - 12 Stick Sachets

      if (
        this.currentVariant.option1 == "Unflavoured" &&
        this.currentVariant.option2 == "12 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#1a262e99");
        $(".nutrition-table").css("color", "#fff");
        $(".ingredients").css("border-top-color", "#fff");
        $(".svgspath.tooltip").css("display", "none");
        $(".product-form__quantity").css("display", "block");

        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "un12";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));

        const mainImgAlt = "unmain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      }

      // Sample Pack

      if (
        this.currentVariant.option1 == "Sample Pack" &&
        this.currentVariant.option2 == "5 x Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "rgba(26, 38, 46, 0.6)");
        $(".nutrition-table").css("color", "#fff");
        $(".ingredients").css("border-top-color", "#fff");
        $(".svgspath.tooltip").css("display", "none");
        $(".product-form__quantity").css("display", "block");

        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
          
        // Show ONLY the Sample Pack main image
          const mainImgAlt = "spmain";
          const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
          document.querySelectorAll(thumbnailSelectormain).forEach((img) => (img.style.display = "block"));
      }




      // Raspberry Lemonade

      if (
        this.currentVariant.option1 == "Raspberry Lemonade" &&
        this.currentVariant.option2 == "12 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#E30B5D");
        $(".nutrition-table").css("color", "#fff");
        $(".ingredients").css("border-top-color", "#fff");
        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "rl12";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "rlmain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      } else if (
        this.currentVariant.option1 == "Raspberry Lemonade" &&
        this.currentVariant.option2 == "30 Stick Sachets"
      ) {
        $(".nutrition-card").css("background-color", "#E30B5D");
        $(".nutrition-table").css("color", "#fff");
        $(".ingredients").css("border-top-color", "#fff");

        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "rl30";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "rlmain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      }

      if (this.currentVariant.option1 == "Unflavoured") {
        $("#template--24097599783187__main-2-1").next().addClass("disbale"); // Hide 30 Stick Sachets
        $("#template--24097599783187__main-2-0").click(); // Select 12 Stick Sachets
      }
      // } else if (this.currentVariant.option1 == "Raspberry Lemonade") {
      //   $("#template--24097599783187__main-2-1").next().addClass("disbale"); // Hide 30 Stick Sachets
      //   $("#template--24097599783187__main-2-0").click(); // Select 12 Stick Sachets
      // }     
      else {
        $("#template--24097599783187__main-2-1").next().removeClass("disbale");
        $("#template--24097599783187__main-2-0").next().removeClass("disbale");
      }
 

      // Variety Pack

      if (
        this.currentVariant.option1 == "Variety Pack" &&
        this.currentVariant.option2 == "12 Stick Sachets"
      ) {
        $("#template--24097599783187__main-2-0").next().addClass("disbale");
        $("#template--24097599783187__main-2-1").click();
        $(
          "#template--24097599291667__6945023a-5967-4fad-b4cf-a7ba3a12842d-2-1"
        ).click();
      }
      if (
        this.currentVariant.option1 == "Variety Pack" &&
        this.currentVariant.option2 == "30 Stick Sachets"
      ) {
        document
          .querySelectorAll("[thumbnail-alt]")
          .forEach((img) => (img.style.display = "none"));
        const currentImgAlt = "v30";
        const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelector)
          .forEach((img) => (img.style.display = "block"));
        const mainImgAlt = "vmain";
        const thumbnailSelectormain = `[thumbnail-alt = '${mainImgAlt}']`;
        document
          .querySelectorAll(thumbnailSelectormain)
          .forEach((img) => (img.style.display = "block"));
      }

      if (this.currentVariant.option1 == "Variety Pack") {
        $("#template--24097599783187__main-2-0").next().addClass("disbale");
        $("#template--24097599291667__6945023a-5967-4fad-b4cf-a7ba3a12842d-2-0")
          .next()
          .addClass("disbale");
      } else {
        $("#template--24097599783187__main-2-0").next().removeClass("disbale");
        $("#template--24097599291667__6945023a-5967-4fad-b4cf-a7ba3a12842d-2-0")
          .next()
          .removeClass("disbale");
      }


    } else {
      // show all thumbnails
      document
        .querySelectorAll("[thumbnail-alt]")
        .forEach((img) => (img.style.display = "block"));
    }
    if (optionBunle1 == "12 pack bundle") {
      $(".bundletextchange").text(
        "Add your 3 flavours for your 12 pack sachets"
      );
      $(".only12pack").css("display", "block");
    }
    if (optionBunle1 == "30 pack bundle") {
      $(".bundletextchange").text(
        "Add your 4 flavours for your 30 pack sachets"
      );
      $(".only12pack").css("display", "none");
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "visibility-hidden",
            pricePerItemSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    if (pricePerItem) pricePerItem.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Function to select variant by ID
function selectVariantById(variantId, variantSelectsElement) {
  // Get variant data
  const variantData = JSON.parse(
    variantSelectsElement.querySelector('script[type="application/json"]').textContent
  );

  // Find the variant
  const variant = variantData.find(v => v.id === parseInt(variantId));
  if (!variant) return;

  // Update option selects/radios
  const selects = variantSelectsElement.querySelectorAll('select');
  selects.forEach((select, index) => {
    const optionValue = variant[`option${index + 1}`];
    if (optionValue) {
      select.value = optionValue;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Handle radio buttons if using variant-radios
  const radios = variantSelectsElement.querySelectorAll('input[type="radio"]');
  radios.forEach((radio) => {
    const optionIndex = Array.from(radio.closest('fieldset').querySelectorAll('input[type="radio"]')).indexOf(radio);
    const fieldsetIndex = Array.from(variantSelectsElement.querySelectorAll('fieldset')).indexOf(radio.closest('fieldset'));
    const optionValue = variant[`option${fieldsetIndex + 1}`];

    if (radio.value === optionValue) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}

// Initialize image click handlers
function initializeImageVariantSelection() {
  // Find all media items with variant data
  const mediaItems = document.querySelectorAll('[data-variant-id]');

  mediaItems.forEach((mediaItem) => {
    const clickableElement = mediaItem.querySelector('button, img, a');
    if (!clickableElement) return;

    clickableElement.addEventListener('click', (e) => {
      // Don't interfere with existing gallery navigation
      const variantId = mediaItem.getAttribute('data-variant-id');
      if (!variantId) return;

      // Find the variant-selects or variant-radios element
      const variantPicker = document.querySelector('variant-selects, variant-radios');
      if (!variantPicker) return;

      // Select the variant
      selectVariantById(variantId, variantPicker);
    });
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initializeImageVariantSelection);
document.addEventListener('shopify:section:load', initializeImageVariantSelection);

// Function to normalize a string to handle format (for comparison)
function normalizeToHandle(str) {
  if (!str) return '';
  return str
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single
    .replace(/^-|-$/g, ''); // Remove leading/trailing hyphens
}

// Function to find variant by matching alt text to option values
function findVariantByAltText(altText, variantSelectsElement) {
  if (!altText) return null;

  // Get variant data
  const variantData = JSON.parse(
    variantSelectsElement.querySelector('script[type="application/json"]').textContent
  );

  // Normalize the alt text
  const normalizedAlt = normalizeToHandle(altText);
  if (!normalizedAlt) return null;

  // Find variant where any option matches the alt text
  const matchingVariant = variantData.find(variant => {
    // Check option1, option2, option3
    const option1Handle = normalizeToHandle(variant.option1);
    const option2Handle = normalizeToHandle(variant.option2);
    const option3Handle = normalizeToHandle(variant.option3);

    return option1Handle === normalizedAlt ||
      option2Handle === normalizedAlt ||
      option3Handle === normalizedAlt;
  });

  return matchingVariant;
}

// Initialize image click handlers based on alt text
function initializeImageVariantSelection() {
  // Find all media items (both main gallery and thumbnails)
  const mediaItems = document.querySelectorAll('.product__media-item, .thumbnail-list__item');

  mediaItems.forEach((mediaItem) => {
    // Get the alt text from the image or the thumbnail-alt attribute
    let altText = null;

    // Try to get from thumbnail-alt attribute (used in your code)
    const thumbnailAlt = mediaItem.getAttribute('thumbnail-alt') ||
      mediaItem.getAttribute('thumbnail-altt');

    // Try to get from image alt attribute
    const img = mediaItem.querySelector('img');
    if (img && img.alt) {
      altText = img.alt;
    } else if (thumbnailAlt) {
      altText = thumbnailAlt;
    }

    if (!altText) return;

    // Find clickable elements (button, img, or the li itself)
    const clickableElement = mediaItem.querySelector('button, img, a') || mediaItem;

    // Add click handler
    clickableElement.addEventListener('click', (e) => {
      // Prevent default if it's a link
      if (clickableElement.tagName === 'A') {
        e.preventDefault();
      }

      // Find the variant-selects or variant-radios element
      const variantPicker = document.querySelector('variant-selects, variant-radios');
      if (!variantPicker) return;

      // Find variant by alt text
      const variant = findVariantByAltText(altText, variantPicker);
      if (!variant) {
        console.log('No variant found matching alt text:', altText);
        return;
      }

      // Select the variant using existing function
      selectVariantById(variant.id, variantPicker);
    });
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initializeImageVariantSelection);
document.addEventListener('shopify:section:load', initializeImageVariantSelection);